module.exports = __webpack_public_path__ + "015e24c6012398dae7797eb06935a3cb.fbx";